export default {
  CRM: 'CRM',
  CE: 'CE',
  COMMUNICATIONS: 'Communications',
  PERMITS: 'Permits'
}
